module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"searchControl":"Chercher un contrôle","town":"Commune","street":"Rue","streetNumber":"Numéro de police","noPropertiesFound":"Aucune propriété trouvé","Controls":"Contrôles","controls":"contrôles","loading":"Chargement...","folderNumber":"N° dossier","filter":"Filtrer"}}')
  delete Component.options._Ctor
}
